// Preserve existing additive/group behavior while avoiding redundant updates.
export const selectWidget = (file, field, additive = false) => {
  const temp = file.document.tempFields;
  const target =
    temp.formFields.find((item) => item.name === field.name) || field;
  const extras = temp.selectedExtraFields || [];
  const alreadySelected = extras.some((item) => item.name === target.name);
  const selectedExtraFields = alreadySelected
    ? extras
    : additive
      ? [...extras, target]
      : [target];
  if (
    temp.selectedFormField === target &&
    selectedExtraFields === extras &&
    !temp.selectedPdfTextItem &&
    !(temp.selectedExtraPdfTextItems || []).length
  ) {
    return file;
  }
  return {
    ...file,
    document: {
      ...file.document,
      tempFields: {
        ...temp,
        selectedFormField: target,
        selectedExtraFields,
        selectedPdfTextItem: null,
        selectedExtraPdfTextItems: [],
      },
    },
  };
};
